import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaGavel, FaPassport, FaHome, FaFlag, FaCheckCircle, FaUsers, FaClock, FaEuroSign, FaUserCheck, FaGlobe, FaLaptop, FaLightbulb, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import './Home.css';
import businessImage from '../assets/image2/business.jpeg';

const Home = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const { t } = useTranslation();

  const services = [
    { icon: <FaGavel />, titleKey: 'services.items.0', color: '#ff6b6b' },
    { icon: <FaPassport />, titleKey: 'services.items.1', color: '#4ecdc4' },
    { icon: <FaHome />, titleKey: 'services.items.2', color: '#45b7d1' },
    { icon: <FaFlag />, titleKey: 'services.items.3', color: '#f9ca24' }
  ];

  const avantages = [
    { icon: <FaUsers />, titleKey: 'why.items.0.title', descriptionKey: 'why.items.0.description' },
    { icon: <FaCheckCircle />, titleKey: 'why.items.1.title', descriptionKey: 'why.items.1.description' },
    { icon: <FaClock />, titleKey: 'why.items.2.title', descriptionKey: 'why.items.2.description' },
    { icon: <FaEuroSign />, titleKey: 'why.items.3.title', descriptionKey: 'why.items.3.description' },
    { icon: <FaUserCheck />, titleKey: 'why.items.4.title', descriptionKey: 'why.items.4.description' },
    { icon: <FaGlobe />, titleKey: 'why.items.5.title', descriptionKey: 'why.items.5.description' },
    { icon: <FaLaptop />, titleKey: 'why.items.6.title', descriptionKey: 'why.items.6.description' },
    { icon: <FaLightbulb />, titleKey: 'why.items.7.title', descriptionKey: 'why.items.7.description' }
  ];

  return (
    <div className="home-page">
      {/* Section Hero */}
      <section className="hero-section">
        <div className="hero-image-container">
          <img src="/images/drapeau.png" alt="IBERMAROC BRIDGE" className="hero-background-image" />
        </div>
        <div className="hero-overlay"></div>
        <div className="container">
          <div className="row align-items-center min-vh-100">
            <div className="col-lg-8 mx-auto text-center">
              <h1 className="hero-title animate-fade-in">{t('app.title')}</h1>
              <p className="hero-subtitle animate-fade-in-delay">{t('hero.subtitle')}</p>
              <p className="hero-description animate-fade-in-delay-2">{t('hero.description')}</p>
              <Link to="/diagnostic" className="btn btn-hero animate-fade-in-delay-3">
                {t('hero.cta')}
              </Link>
              <div className="hero-logo-container animate-fade-in-delay-4">
                <img src="/images/logo.jpeg" alt="IBERMAROC BRIDGE" className="hero-logo-home" />
              </div>
            </div>
          </div>
        </div>
        <div className="hero-scroll-indicator">
          <div className="scroll-arrow"></div>
        </div>
      </section>

      {/* Section Services rapides */}
      <section className="services-section py-5">
        <div className="container">
          <h2 className="section-title text-center mb-5">{t('services.title')}</h2>
          <div className="row g-4 align-items-stretch">
            <div className="col-lg-6">
              <div className="row g-4">
                {services.map((service, index) => (
                  <div key={index} className="col-lg-6 col-md-6">
                    <div className="service-card">
                      <div className="service-icon" style={{ color: service.color }}>
                        {service.icon}
                      </div>
                      <h3 className="service-title">{t(service.titleKey)}</h3>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <div className="col-lg-6">
              <div className="home-school-image-container">
                <img src={businessImage} alt="Bureau" className="home-school-image" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section Pourquoi nous choisir */}
      <section className="why-section py-5">
        <div className="container">
          <h2 className="section-title text-center mb-5">{t('why.title')}</h2>
          <div className="carousel-container">
            <button 
              className="carousel-btn carousel-btn-prev"
              onClick={() => setActiveIndex((prev) => (prev === 0 ? avantages.length - 1 : prev - 1))}
              aria-label={t('common.carousel.prev')}
            >
              <FaChevronLeft />
            </button>
            <div className="carousel-wrapper">
              <div 
                className="carousel-track"
                style={{ 
                  transform: `translateX(calc(50% - ${activeIndex * 236 + 225}px))` 
                }}
              >
                {avantages.map((avantage, index) => (
                  <div 
                    key={index} 
                    className={`carousel-slide ${index === activeIndex ? 'active' : ''}`}
                  >
                    <div className="advantage-card">
                      <div className="advantage-icon">
                        {avantage.icon}
                      </div>
                      <h4 className="advantage-title">{t(avantage.titleKey)}</h4>
                      <p className="advantage-description">{t(avantage.descriptionKey)}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <button 
              className="carousel-btn carousel-btn-next"
              onClick={() => setActiveIndex((prev) => (prev === avantages.length - 1 ? 0 : prev + 1))}
              aria-label={t('common.carousel.next')}
            >
              <FaChevronRight />
            </button>
          </div>
          <div className="carousel-dots">
            {avantages.map((_, index) => (
              <button
                key={index}
                className={`carousel-dot ${index === activeIndex ? 'active' : ''}`}
                onClick={() => setActiveIndex(index)}
                aria-label={t('common.carousel.goToSlide', { n: index + 1 })}
              />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
